const ROLES = {
    ADMIN: [
        'canViewDashboard',
        'canViewSettings',
        'canCreateItem',
        'canUpdateItem',
        'canDeleteItem'
    ],
    USER: ['canViewDashboard']
};

export default ROLES;



// WEBPACK FOOTER //
// ./src/app/helpers/permissions.js